import { useEffect } from "react"
import type { ReactElement } from "react"
import { connect } from "react-redux"
import {
  createLinkChapter,
  fetchAllLicences,
  fetchLinkChapter,
  loadDefaultLinkChapter,
  updateLinkChapter
} from "../../../../../redux"
import type { AppState, AppThunkDispatch, Licence, LinkChapter, LinkChapterActions } from "../../../../../redux"
import { BackButton, PageContainer } from "../../../../molecules"
import { LinkChapterManagerForm } from "../../../../organisms"

export interface ILinkChapterManagerPageProps {
  chapter: LinkChapter
  licences: Licence[]
  fetchChapter: (id: string) => void
  fetchDefaultChapter: () => void
  createChapter: (chapter: LinkChapter) => void
  updateChapter: (chapter: LinkChapter) => void
  fetchLicences: () => void
}

export interface ILinkChapterManagerRouteParams {
  chapterId?: string
}

function LinkChapterManagerPageView(
  props: ILinkChapterManagerPageProps & ILinkChapterManagerRouteParams
): ReactElement {
  const {
    chapterId,
    chapter,
    licences,
    fetchChapter,
    fetchDefaultChapter,
    createChapter,
    updateChapter,
    fetchLicences
  } = props
  // biome-ignore lint/correctness/useExhaustiveDependencies: TODO in a later PR
  useEffect(() => {
    fetchLicences()
    if (chapterId && chapterId !== chapter.id) {
      fetchChapter(chapterId)
    } else if (!chapterId) {
      fetchDefaultChapter()
    }
  }, [])

  function hasLoaded(): boolean {
    if (chapterId === chapter.id || !chapterId) {
      return true
    }
    return false
  }

  function handleSave(chapter: LinkChapter): void {
    if (chapter.id) {
      updateChapter(chapter)
    } else {
      createChapter(chapter)
    }
  }

  return (
    <PageContainer hasLoaded={hasLoaded()} id="chapter-manager-page" smallPadding>
      <BackButton />
      <LinkChapterManagerForm chapter={chapter} licences={licences} saveChapter={handleSave} />
    </PageContainer>
  )
}

function mapStateToProps(state: AppState, ownProps: ILinkChapterManagerRouteParams) {
  return {
    chapterId: ownProps.chapterId,
    chapter: state.linkChapters.linkChapter,
    licences: state.licences.licences
  }
}

function mapDispatchToProps(dispatch: AppThunkDispatch<LinkChapterActions>) {
  return {
    fetchChapter: (id: string) => dispatch(fetchLinkChapter(id)),
    fetchDefaultChapter: () => dispatch(loadDefaultLinkChapter()),
    createChapter: (chapter: LinkChapter) => dispatch(createLinkChapter(chapter)),
    updateChapter: (chapter: LinkChapter) => dispatch(updateLinkChapter(chapter)),
    fetchLicences: () => dispatch(fetchAllLicences())
  }
}

export const LinkChapterManagerPage = connect(mapStateToProps, mapDispatchToProps)(LinkChapterManagerPageView)
